const Employers = () => import('@/views/Errors/HttpError');

export default [
  {
    path: '/error',
    name: 'httperror',
    component: Employers,
  },
];
